<script>
import IconX from "@js/components/Icons/IconX.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import {ref} from "vue";

export default {
    name: "CatalogSelectedFilterTags",
    components: {IconX},
    setup() {
        const catalogStore = useCatalogStore();
        const visibleTagsLimit = 3;
        const showAllTags = ref(false);

        const toggleShowAllTags = () => {
            showAllTags.value = !showAllTags.value;
        };

        return {
            catalogStore,
            visibleTagsLimit,
            showAllTags,
            toggleShowAllTags,
        };
    },
};
</script>

<template>
    <template v-if="catalogStore.selected_filters.length">
        <div v-for="(tag, index) in catalogStore.selected_filters" :key="`${tag.field}-${tag.value}`">
            <div
                v-if="showAllTags || index < visibleTagsLimit"
                :class="{'ms-2': index === 0 }"
                @click.prevent="catalogStore.removeFilter(tag)"
                class="group flex items-center cursor-pointer bg-gray-200 md:hover:bg-baseColor md:hover:text-black transition rounded md:rounded-full me-2 md:my-2"
            >
                <div class="font-semibold text-xs text-nowrap py-2 ps-4 pe-2">
                    {{ tag.title }}
                </div>
                <div class="group-hover:bg-black/50 rounded md:rounded-full h-full p-2 transition">
                    <IconX class="group-hover:stroke-white second:hover:stroke-black w-3.5 h-3.5 transition"/>
                </div>
            </div>
        </div>

        <div
            v-if="catalogStore.selected_filters.length > visibleTagsLimit"
            @click.prevent="toggleShowAllTags"
            class="text-xs text-nowrap font-semibold cursor-pointer py-2 px-4 md:my-2 rounded md:rounded-full bg-gray-300 md:hover:bg-baseColor md:hover:text-black"
        >
            {{ showAllTags ? 'Скрыть' : `Еще (${catalogStore.selected_filters.length - visibleTagsLimit})` }}
        </div>
    </template>
</template>
